// vue
import { computed, PropType } from 'vue';

// types
import { Props, Context } from '../types';
import type { IExchange } from '@/types/exchanges';

// store
import { useGl } from '@store/ts/gl';
import { useRefs } from '@store/ts/refs';

// Общие пропсы
export const generalProps = {
    exchangeId: {
        type: Number as PropType<Props['exchangeId']>,
        required: true,
    },
};

export const shared = (props: Readonly<Props>, context: Context) => {
    // store
    const gl = useGl();
    const refs = useRefs();

    const lightExchangeIcons: { [key: string ]: string} = {
        'cex': 'https://app.revenuebot.io/images/exchanges/cexio.svg',
        'bitfinex': 'https://app.revenuebot.io/images/exchanges/bitfinex.svg',
        'bittrex': 'https://app.revenuebot.io/images/exchanges/bittrex.svg',
        'poloniex': 'https://app.revenuebot.io/images/exchanges/poloniex.svg',
        'binance': 'https://app.revenuebot.io/images/exchanges/binance.svg',
        'wex': 'https://app.revenuebot.io/images/exchanges/wex.svg',
        'exmo': 'https://app.revenuebot.io/images/exchanges/exmo.svg',
        'livecoin': 'https://app.revenuebot.io/images/exchanges/livecoin.svg',
        'hitbtc': 'https://app.revenuebot.io/images/exchanges/hitbtc.svg',
        'okex': 'https://app.revenuebot.io/images/exchanges/okex.svg',
        'okex_f': 'https://app.revenuebot.io/images/exchanges/okex-futures.svg',
        'bitmax': 'https://app.revenuebot.io/images/exchanges/bitmax.svg',
        'kraken': 'https://app.revenuebot.io/images/exchanges/kraken.svg',
        'kucoin': 'https://app.revenuebot.io/images/exchanges/kucoin.svg',
        'kucoin_f': 'https://app.revenuebot.io/images/exchanges/kucoin_f.svg',
        'binance_f': 'https://app.revenuebot.io/images/exchanges/binance-futures.svg',
        'binance_fc': 'https://app.revenuebot.io/images/exchanges/binance-coin-m.svg',
        'ftx': 'https://app.revenuebot.io/images/exchanges/ftx.svg',
        'binanceus': 'https://app.revenuebot.io/images/exchanges/binanceus.svg',
        'bitget': 'https://app.revenuebot.io/images/exchanges/bitget.svg',
        'bitget_f': 'https://app.revenuebot.io/images/exchanges/bitget_f.svg',
        'bitget_fc': 'https://app.revenuebot.io/images/exchanges/bitget_fc.svg',
        'gate': 'https://app.revenuebot.io/images/exchanges/gate.svg',
        'gate_f': 'https://app.revenuebot.io/images/exchanges/gate_f.svg',
        'bybit': 'https://app.revenuebot.io/images/exchanges/bybit.svg',
        'bybit_f': 'https://app.revenuebot.io/images/exchanges/bybit_f.svg',
        'huobi': 'https://app.revenuebot.io/images/exchanges/huobi.svg',
        'huobi_f': 'https://app.revenuebot.io/images/exchanges/huobi_f.svg',
        'binance_t': 'https://app.revenuebot.io/images/exchanges/binance_t.svg',
        'binance_tf': 'https://app.revenuebot.io/images/exchanges/binance_tf.svg',
        'exmome': 'https://app.revenuebot.io/images/exchanges/exmome.svg',
        'commex': 'https://app.revenuebot.io/images/exchanges/commex.svg',
        'commex_f': 'https://app.revenuebot.io/images/exchanges/commex_f.svg',
        'bingx': 'https://app.revenuebot.io/images/exchanges/bingx.svg',
        'bingx_f': 'https://app.revenuebot.io/images/exchanges/bingx_f.svg',
        'mexc': 'https://app.revenuebot.io/images/exchanges/mexc.svg',
    };

    const darkExchangeIcons: { [key: string ]: string} = {
        'cex': 'https://app.revenuebot.io/images/exchanges/cexio__DARK.svg',
        'bitfinex': 'https://app.revenuebot.io/images/exchanges/bitfinex__DARK.svg',
        'bittrex': 'https://app.revenuebot.io/images/exchanges/bittrex__DARK.svg',
        'poloniex': 'https://app.revenuebot.io/images/exchanges/poloniex__DARK.svg',
        'binance': 'https://app.revenuebot.io/images/exchanges/binance__DARK.svg',
        'wex': 'https://app.revenuebot.io/images/exchanges/wex__DARK.svg',
        'exmo': 'https://app.revenuebot.io/images/exchanges/exmo__DARK.svg',
        'livecoin': 'https://app.revenuebot.io/images/exchanges/livecoin__DARK.svg',
        'hitbtc': 'https://app.revenuebot.io/images/exchanges/hitbtc__DARK.svg',
        'okex': 'https://app.revenuebot.io/images/exchanges/okex__DARK.svg',
        'okex_f': 'https://app.revenuebot.io/images/exchanges/okex-futures__DARK.svg',
        'bitmax': 'https://app.revenuebot.io/images/exchanges/bitmax__DARK.svg',
        'kraken': 'https://app.revenuebot.io/images/exchanges/kraken__DARK.svg',
        'kucoin': 'https://app.revenuebot.io/images/exchanges/kucoin__DARK.svg',
        'kucoin_f': 'https://app.revenuebot.io/images/exchanges/kucoin_f__DARK.svg',
        'binance_f': 'https://app.revenuebot.io/images/exchanges/binance-futures__DARK.svg',
        'binance_fc': 'https://app.revenuebot.io/images/exchanges/binance-coin-m__DARK.svg',
        'ftx': 'https://app.revenuebot.io/images/exchanges/ftx__DARK.svg',
        'binanceus': 'https://app.revenuebot.io/images/exchanges/binanceus__DARK.svg',
        'bitget': 'https://app.revenuebot.io/images/exchanges/bitget__DARK.svg',
        'bitget_f': 'https://app.revenuebot.io/images/exchanges/bitget_f__DARK.svg',
        'bitget_fc': 'https://app.revenuebot.io/images/exchanges/bitget_fc__DARK.svg',
        'gate': 'https://app.revenuebot.io/images/exchanges/gate__DARK.svg',
        'gate_f': 'https://app.revenuebot.io/images/exchanges/gate_f__DARK.svg',
        'bybit': 'https://app.revenuebot.io/images/exchanges/bybit__DARK.svg',
        'bybit_f': 'https://app.revenuebot.io/images/exchanges/bybit_f__DARK.svg',
        'huobi': 'https://app.revenuebot.io/images/exchanges/huobi__DARK.svg',
        'huobi_f': 'https://app.revenuebot.io/images/exchanges/huobi_f__DARK.svg',
        'binance_t': 'https://app.revenuebot.io/images/exchanges/binance_t__DARK.svg',
        'binance_tf': 'https://app.revenuebot.io/images/exchanges/binance_tf__DARK.svg',
        'exmome': 'https://app.revenuebot.io/images/exchanges/exmome__DARK.svg',
        'commex': 'https://app.revenuebot.io/images/exchanges/commex__DARK.svg',
        'commex_f': 'https://app.revenuebot.io/images/exchanges/commex_f__DARK.svg',
        'bingx': 'https://app.revenuebot.io/images/exchanges/bingx__DARK.svg',
        'bingx_f': 'https://app.revenuebot.io/images/exchanges/bingx_f__DARK.svg',
        'mexc': 'https://app.revenuebot.io/images/exchanges/mexc__DARK.svg',
    };

    const exchange = (): IExchange | undefined => refs.exchanges.find(el => el.id == props.exchangeId);

    const link = computed(() => {
        const ex = exchange();
        if (ex) {
            return gl.darkTheme ? darkExchangeIcons[ex.code_name] : lightExchangeIcons[ex.code_name];
        }

        return '';
    });

    return {
        gl,
        link,
    };
};